import type { API } from 'chessboard/api/config/types';
import { isFirstNodeInLine } from 'model/move/is-first-node-in-line';

/**
 * Create the getHistoryFENs method.
 */
export function createGetHistoryFENs(context: API.Context) {
  /**
   * Get an array of FENs for each move in the current history.
   */
  return function getHistoryFENs(toEndOfCurrentLine = false) {
    const { game } = context;

    // eslint-disable-next-line no-underscore-dangle
    const pos = game._getPos();

    // if the line id is 0, and we are at starting node and we have a fen, then we are at the starting position
    if (pos.ids && pos.ids.line === 0 && isFirstNodeInLine(pos.ids.move) && pos.fen) {
      return [pos.fen];
    }

    return game
      .history({ toCurrent: !toEndOfCurrentLine, verbose: true })
      .map((gameMove) => gameMove.fen);
  };
}
